/* Carrinho em gaveta: o "+" das sugestões (mais vendidos) adiciona sem sair da gaveta.
   Modelo da Pzado, 03/11/2026. Peça com variação exige a escolha no seletor antes. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cj-sk-add]');
    if (!btn) return;
    var item = btn.closest('[data-cj-sk]');
    var sel = item && item.querySelector('[data-cj-sk-var]');
    var id = btn.getAttribute('data-id') || (sel && sel.value);
    if (!id) {
      if (sel) { sel.classList.add('cj-sk__var--pede'); sel.focus(); }
      return;
    }
    var gaveta = document.querySelector('cart-drawer');
    btn.disabled = true;
    btn.classList.add('cj-sk__add--carregando');
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'HTTP ' + r.status);
          return j;
        });
      })
      .then(function (j) {
        if (gaveta && gaveta.renderContents && j.sections) {
          j.id = j.items && j.items[0] ? j.items[0].id : null;
          gaveta.classList.remove('is-empty');
          gaveta.renderContents(j);
        } else {
          location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) {
        console.error('[Cajueiro] sugestão não entrou no carrinho', err);
        btn.disabled = false;
        btn.classList.remove('cj-sk__add--carregando');
        btn.setAttribute('aria-label', 'Não deu certo: ' + err.message);
      });
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cj-sk-var]')) e.target.classList.remove('cj-sk__var--pede');
  });
})();
